import { SmartfireComponent, smartProps } from '@smartfire/gutenberg-react';
import React from 'react';
import './style.scss';
import './editor.scss';
import CapsaTitle from '../CapsaTitle/block.js';
import { PlainText } from '@wordpress/editor';
import { Fragment } from '@wordpress/element';
import { SelectControl, PanelBody } from '@wordpress/components';

export default class TitleTextBlock extends SmartfireComponent {
    static title = 'Bloc Titre + description';

    static smartProps = {
        titleTag: smartProps.any.withDefault('h2'),
        description: smartProps.string.isRequired,
        containerBgColor: smartProps.any.withDefault(''),
    };

    renderEditInspector() {
        return (
            <Fragment>
                <PanelBody title={SmartfireComponent.__("Couleur d'arrière plan")}>
                    <SelectControl
                        label="Couleur de fond de page"
                        value={this.props.containerBgColor}
                        options={[
                            { label: 'Blanc', value: 'bg-white' },
                            { label: 'Gris foncé', value: 'bg-grey' },
                            { label: 'Gris clair', value: 'bg-lightgrey' },
                            { label: 'Bleu', value: 'bg-blue' },
                        ]}
                        onChange={(containerBgColor) => {
                            this.setAttributes({ containerBgColor: containerBgColor });
                        }}
                    />
                </PanelBody>
                <PanelBody title={SmartfireComponent.__('SEO')}>
                    <SelectControl
                        label="Hn"
                        value={this.props.titleTag}
                        options={[
                            { label: 'H1', value: 'h1' },
                            { label: 'H2', value: 'h2' },
                            { label: 'p', value: 'p' },
                        ]}
                        onChange={(titleTag) => {
                            this.setAttributes({ titleTag: titleTag });
                        }}
                    />
                </PanelBody>
            </Fragment>
        );
    }

    render() {
        console.log(this.props.titleTag);
        if (this.isEditing) {
            return (
                <div className="flow-title-block">
                    <h2>Bloc Texte + description</h2>
                    <PlainText
                        onChange={(content) => this.setAttributes({ title: content })}
                        value={this.props.title}
                        placeholder="Title"
                        className="heading title"
                    />
                    <PlainText
                        onChange={(content) =>
                            this.setAttributes({ description: content })
                        }
                        value={this.props.description}
                        placeholder="Description text"
                        className="description"
                    />
                </div>
            );
        } else {
            return (
                <div className={`${'title-text-block'} ${this.props.containerBgColor}`}>
                    <div className="content-container">
                        {(this.props.containerBgColor === 'bg-white' ||
                            this.props.containerBgColor === undefined) && (
                            <CapsaTitle
                                title={this.props.title}
                                bg={'grey'}
                                type={this.props.titleTag}
                            />
                        )}
                        {(this.props.containerBgColor === 'bg-grey' ||
                            this.props.containerBgColor === 'bg-lightgrey') && (
                            <CapsaTitle
                                title={this.props.title}
                                bg={'white'}
                                type={this.props.titleTag}
                            />
                        )}
                        {this.props.containerBgColor === 'bg-blue' && (
                            <CapsaTitle
                                title={this.props.title}
                                bg={'light-blue'}
                                type={this.props.titleTag}
                            />
                        )}
                        {this.props.description && (
                            <p className="description">{this.props.description}</p>
                        )}
                        <div className="separator"></div>
                    </div>
                </div>
            );
        }
    }
}
